import { api } from "api/api";
import { AxiosError } from "axios";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class UnidadeOrganizacionalService implements BaseServiceCadastros<UnidadeOrganizacional> {
    getListaRegimeTributario() {
        return [
            { value: "SIMPLES_NACIONAL", label: "Simples Nacional" },
            { value: "SIMPLES_NACIONAL_EXCESSO_SUBLIMITE", label: "Simples Nacional - excesso de sublimite" },
            { value: "REGIME_NORMAL", label: "Regime normal" },
            { value: "MEI", label: "Microempreendedor individual" }
        ];
    }

    getAll() {
        return new Promise<UnidadeOrganizacional[]>((resolve, reject): void => {
            api
                .get(`/unidadeOrganizacional/getAll`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/unidadeOrganizacional/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<UnidadeOrganizacional>((resolve, reject): void => {
            api
                .get(`/unidadeOrganizacional/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(unidadeOrganizacional: UnidadeOrganizacional) {
        return new Promise<UnidadeOrganizacional>((resolve, reject): void => {
            let url = `/unidadeOrganizacional/incluir`;
            api
                .post(url, JSON.stringify(unidadeOrganizacional))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(unidadeOrganizacional: UnidadeOrganizacional) {
        return new Promise<UnidadeOrganizacional>((resolve, reject): void => {
            api
                .put(`/unidadeOrganizacional/editar`, JSON.stringify(unidadeOrganizacional))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/unidadeOrganizacional/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default UnidadeOrganizacionalService;
